import React from "react";
import classNames from "classnames";
import { BemHelper } from "../utils/BemHelper";
import { CirclePlusIcon } from "../icons/circle-plus-icon";
import defaultImage from "./images/default-product.jpeg";
import { useBreakpointValue } from "../utils";

type Props = {
  onClick?: () => void;
  hasProducts?: boolean;
  image?: string;
};

const bem = new BemHelper("product-create-card");

export const ProductCreateCard: React.FC<Props> = ({ hasProducts = true, onClick, image }) => {
  const isMobile = useBreakpointValue({ base: false, xs: true });

  return (
    <a className={classNames(bem.block())} onClick={() => onClick && onClick()}>
      <div className={classNames(bem.element("image"), isMobile && bem.element("image-mobile"))}>
        <img src={image || defaultImage} />
      </div>
      <div className={classNames(bem.element("content"))}>
        <div className={classNames(bem.element("call-to-action"))}>
          <CirclePlusIcon />
          <div className={classNames(bem.element("title"))}>
            {hasProducts ? "Add New Product" : "Add Your First Product"}
          </div>
        </div>
      </div>
    </a>
  );
};
